/**
 * Reset all typography attributes
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import type { TypographyAttributes } from '../../types';

/**
 * Reset all typography attributes
 */
export const resetTypographyAttributes =
	(): Partial< TypographyAttributes > => {
		return {
			desktop: {},
			tablet: {},
			mobile: {},
		};
	};
